export const isTryMode = () => {
  if (typeof window === 'undefined') return false;
  return window.name === 'trymode';
};
